import React from "react";
import {
  Dashboard as DashboardIcon,
  Store as StoreIcon,
  MenuBook as MenuBookIcon,
} from "@material-ui/icons";
import BusinessIcon from "@material-ui/icons/Business";
import SettingsIcon from "@material-ui/icons/Settings";
import CenterFocusWeakIcon from "@material-ui/icons/CenterFocusWeak";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BallotIcon from "@material-ui/icons/Ballot";
import { ROUTES } from "shared/constants/routes";
import StaplesLogo from "assets/images/staples.jpeg";
import AmericanDiversityLogo from "assets/images/american_diversity.png";
import AmericanBusinessLogo from "assets/images/american-business.jpeg";
import BlinkSwagLogo from "assets/images/blink-swag.png";
import WamiSwagLogo from "assets/images/wamiswag.png";
import IPULogo from "assets/images/ipu-logo.png";
import ProformaLogo from "assets/images/proforma-logo.jpeg";
import CottonCandyLogo from "assets/images/cotton-candy-logo.jpeg";
// import Brikl from 'assets/images/brikl.png';

const DRAWER_ITEMS = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    route: ROUTES.DASHBOARD.LINK,
  },
  {
    title: "My Stores",
    icon: <StoreIcon />,
    childItems: [
      {
        title: "Stores",
        route: ROUTES.MY_STORES.LINK,
      },
      {
        title: ROUTES.MY_STORES_SYNC_PRODUCTS.TITLE,
        route: ROUTES.MY_STORES_SYNC_PRODUCTS.LINK,
      },
    ],
  },
  {
    title: "Orders",
    icon: <DashboardIcon />,
    route: ROUTES.ORDERS.LINK,
  },
  {
    title: "Product & Pricing",
    icon: <MenuBookIcon />,
    route: ROUTES.CATALOG.LINK,
  },
  {
    title: "Mock-Up Generator",
    icon: <CenterFocusWeakIcon />,
    route: ROUTES.MY_STORES_PRODUCTS.LINK,
    newRelease: true,
  },
  {
    icon: <AssessmentIcon />,
    title: ROUTES.USER_SALES_REPORT.TITLE,
    route: ROUTES.USER_SALES_REPORT.LINK,
  },
  {
    icon: <BallotIcon />,
    title: ROUTES.INVENTORY.TITLE,
    route: ROUTES.INVENTORY.LINK,
    inventory: true,
  },
  {
    title: "Account Settings",
    icon: <SettingsIcon />,
    route: ROUTES.ACCOUNT_SETTINGS.LINK,
  },
];

const getDrawerItems = (emailid) => {
  const isAdmin =
    emailid == "developer@bigoventees.com" || emailid == "support@shirtly.com";

  const tempAdmin = emailid === "brandonv@bigoventees.com";
  if (isAdmin) {
    return [
      {
        title: "Admin",
        icon: <DashboardIcon />,
        childItems: [
          {
            title: ROUTES.WEB_PAGES.TITLE,
            route: ROUTES.WEB_PAGES.LINK,
          },
          {
            title: "Users",
            route: ROUTES.ADMIN_USERS.LINK,
          },
          {
            title: "All Orders",
            route: ROUTES.WAREHOUSE.LINK,
          },
          {
            title: "Settings",
            route: ROUTES.ADMIN_SETTINGS.LINK,
          },
          {
            title: ROUTES.ADMIN_DTG_PLUS.TITLE,
            route: ROUTES.ADMIN_DTG_PLUS.LINK,
          },
          {
            title: "Products",
            route: ROUTES.ADMIN_EDIT_PRODUCT.LINK,
          },
          {
            title: ROUTES.ADMIN_SCREEN_PRINTING.TITLE,
            route: ROUTES.ADMIN_SCREEN_PRINTING.LINK,
          },
          {
            title: ROUTES.ADMIN_SALES_REPORT.TITLE,
            route: ROUTES.ADMIN_SALES_REPORT.LINK,
          },
          {
            title: ROUTES.GROUPS.TITLE,
            route: ROUTES.GROUPS.LINK,
          },
          {
            title: ROUTES.ORDER_STOCK.TITLE,
            route: ROUTES.ORDER_STOCK.LINK,
          },
          {
            title: ROUTES.SUBMITTED_ORDER_STOCK.TITLE,
            route: ROUTES.SUBMITTED_ORDER_STOCK.LINK,
          },

          {
            title: ROUTES.FULFILLMENT_DAYS.TITLE,
            route: ROUTES.FULFILLMENT_DAYS.LINK,
          },
        ],
      },
      // {
      //   title: 'IPromoteU',
      //   icon: <img alt="icon" width="70" src={IPULogo} />,
      //   route: ROUTES.I_PROMOTE_U.LINK,
      //   iconOnly: true,
      // },
      {
        title: "Staples",
        icon: <img alt="icon" width="20" src={StaplesLogo} />,
        childItems: [
          {
            title: ROUTES.STAPLES_BULK_ORDERS.TITLE,
            route: ROUTES.STAPLES_BULK_ORDERS.LINK,
          },
          {
            title: ROUTES.STAPLES_ART_FILES.TITLE,
            route: ROUTES.STAPLES_ART_FILES.LINK,
          },
          {
            title: ROUTES.PARTN_BRIGHAM.TITLE,
            route: ROUTES.PARTN_BRIGHAM.LINK,
          },
        ],
      },
      // {
      //   title: "Printify",
      //   icon: (
      //     <img
      //       width="20"
      //       src="https://avatars.githubusercontent.com/u/20637839?s=280&v=4"
      //       alt="printify"
      //     />
      //   ),
      //   childItems: [
      //     {
      //       title: ROUTES.PRINTIFY_INVOICES.TITLE,
      //       route: ROUTES.PRINTIFY_INVOICES.LINK,
      //     },
      //     {
      //       title: ROUTES.PRINTIFY_ORDERS.TITLE,
      //       route: ROUTES.PRINTIFY_ORDERS.LINK,
      //     },
      //   ],
      // },

      //

      {
        title: "Zazzle",
        icon: (
          <img
            width="20"
            src="https://asset.zcache.ca/assets/graphics/z4/uniquePages/zmisc/favicons/apple-touch-icon-114.png"
            alt="printify"
          />
        ),
        childItems: [
          {
            title: ROUTES.ZAZZLE_INVOICES.TITLE,
            route: ROUTES.ZAZZLE_INVOICES.LINK,
          },
        ],
      },

      //
      {
        title: "Connected Stores",
        icon: <BusinessIcon />,
        childItems: [
          {
            title: ROUTES.WAMI_SWAG.TITLE,
            route: ROUTES.WAMI_SWAG.LINK,
            icon: <img src={WamiSwagLogo} alt="wamiswag" width="20" />,
          },
          // {
          //   title: ROUTES.SMART_PRINT_SINK.TITLE,
          //   route: ROUTES.SMART_PRINT_SINK.LINK,
          //   icon: <BusinessIcon />,
          // },

          {
            title: ROUTES.BLINK_SWAG.TITLE,
            route: ROUTES.BLINK_SWAG.LINK,
            icon: <img src={BlinkSwagLogo} alt="orbitkit" width="20" />,
          },

          {
            title: ROUTES.ORBIT_KIT.TITLE,
            route: ROUTES.ORBIT_KIT.LINK,
            icon: (
              <img
                src="https://www.orbitkit.com/img/logo.svg"
                alt="orbitkit"
                width="20"
              />
            ),
          },

          {
            title: ROUTES.PROFORMA.TITLE,
            route: ROUTES.PROFORMA.LINK,
            icon: <img src={ProformaLogo} alt="orbitkit" width="20" />,
          },

          {
            title: ROUTES.COTTON_CANDY.TITLE,
            route: ROUTES.COTTON_CANDY.LINK,
            icon: <img src={CottonCandyLogo} alt="orbitkit" width="20" />,
          },

          // {
          //   title: ROUTES.FAST_PLATFORM.TITLE,
          //   route: ROUTES.FAST_PLATFORM.LINK,
          //   icon: (
          //     <img
          //       src="https://s3.amazonaws.com/static.fastplatform.com/blog/wp-content/uploads/2021/06/16195515/Fast-logo-small.png"
          //       alt="orbitkit"
          //       width="20"
          //     />
          //   ),
          // },

          // {
          //   title: ROUTES.PRINT_YOUR_CAUSE.TITLE,
          //   route: ROUTES.PRINT_YOUR_CAUSE.LINK,
          //   icon: (
          //     <img
          //       src="https://printyourcause.com/_nuxt/img/994ac38.svg"
          //       alt="print_your_cause"
          //       width="20"
          //     />
          //   ),
          // },
          // {
          //   title: ROUTES.BRIKL.TITLE,
          //   route: ROUTES.BRIKL.LINK,
          //   icon: <img src={Brikl} alt="print_your_cause" width="20" />,
          // },

          {
            title: ROUTES.IMS_RETAIL.TITLE,
            route: ROUTES.IMS_RETAIL.LINK,
            icon: (
              <img
                src="https://www.imsretail.com/wp-content/uploads/2020/01/Intergated_Merchandising_Solutions_Dark.png"
                alt="IMS_RETAIL"
                width="20"
              />
            ),
          },

          // {
          //   title: ROUTES.AMERICAN_DIVERSITY.TITLE,
          //   route: ROUTES.AMERICAN_DIVERSITY.LINK,
          //   icon: (
          //     <img src={AmericanDiversityLogo} alt="IMS_RETAIL" width="20" />
          //   ),
          // },

          {
            title: ROUTES.AMERICAN_BUSINESS.TITLE,
            route: ROUTES.AMERICAN_BUSINESS.LINK,
            icon: (
              <img src={AmericanBusinessLogo} alt="IMS_RETAIL" width="20" />
            ),
          },
        ],
      },
      ...DRAWER_ITEMS,
    ];
  }

  if (tempAdmin) {
    return [
      {
        title: "Connected Stores",
        icon: <BusinessIcon />,
        childItems: [
          {
            title: ROUTES.WAMI_SWAG.TITLE,
            route: ROUTES.WAMI_SWAG.LINK,
            icon: <img src={WamiSwagLogo} alt="wamiswag" width="20" />,
          },
          // {
          //   title: ROUTES.SMART_PRINT_SINK.TITLE,
          //   route: ROUTES.SMART_PRINT_SINK.LINK,
          //   icon: <BusinessIcon />,
          // },

          {
            title: ROUTES.BLINK_SWAG.TITLE,
            route: ROUTES.BLINK_SWAG.LINK,
            icon: <img src={BlinkSwagLogo} alt="orbitkit" width="20" />,
          },

          {
            title: ROUTES.ORBIT_KIT.TITLE,
            route: ROUTES.ORBIT_KIT.LINK,
            icon: (
              <img
                src="https://www.orbitkit.com/img/logo.svg"
                alt="orbitkit"
                width="20"
              />
            ),
          },

          {
            title: ROUTES.PROFORMA.TITLE,
            route: ROUTES.PROFORMA.LINK,
            icon: <img src={ProformaLogo} alt="orbitkit" width="20" />,
          },

          {
            title: ROUTES.COTTON_CANDY.TITLE,
            route: ROUTES.COTTON_CANDY.LINK,
            icon: <img src={CottonCandyLogo} alt="orbitkit" width="20" />,
          },

          // {
          //   title: ROUTES.FAST_PLATFORM.TITLE,
          //   route: ROUTES.FAST_PLATFORM.LINK,
          //   icon: (
          //     <img
          //       src="https://s3.amazonaws.com/static.fastplatform.com/blog/wp-content/uploads/2021/06/16195515/Fast-logo-small.png"
          //       alt="orbitkit"
          //       width="20"
          //     />
          //   ),
          // },

          // {
          //   title: ROUTES.PRINT_YOUR_CAUSE.TITLE,
          //   route: ROUTES.PRINT_YOUR_CAUSE.LINK,
          //   icon: (
          //     <img
          //       src="https://printyourcause.com/_nuxt/img/994ac38.svg"
          //       alt="print_your_cause"
          //       width="20"
          //     />
          //   ),
          // },
          // {
          //   title: ROUTES.BRIKL.TITLE,
          //   route: ROUTES.BRIKL.LINK,
          //   icon: <img src={Brikl} alt="print_your_cause" width="20" />,
          // },

          {
            title: ROUTES.IMS_RETAIL.TITLE,
            route: ROUTES.IMS_RETAIL.LINK,
            icon: (
              <img
                src="https://www.imsretail.com/wp-content/uploads/2020/01/Intergated_Merchandising_Solutions_Dark.png"
                alt="IMS_RETAIL"
                width="20"
              />
            ),
          },

          // {
          //   title: ROUTES.AMERICAN_DIVERSITY.TITLE,
          //   route: ROUTES.AMERICAN_DIVERSITY.LINK,
          //   icon: (
          //     <img src={AmericanDiversityLogo} alt="IMS_RETAIL" width="20" />
          //   ),
          // },

          {
            title: ROUTES.AMERICAN_BUSINESS.TITLE,
            route: ROUTES.AMERICAN_BUSINESS.LINK,
            icon: (
              <img src={AmericanBusinessLogo} alt="IMS_RETAIL" width="20" />
            ),
          },
        ],
      },
      ...DRAWER_ITEMS,
    ];
  }

  return DRAWER_ITEMS;
};

export { DRAWER_ITEMS, getDrawerItems };
